






















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import clients from '@/store/modules/clients';
import Config from '@/config';
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class SecondStep extends Vue {
  public name = 'second-step';
  @Prop() private msg!: string;
  @Prop() private client!: any;
  @Prop() private step!: any;

  private show = true;
  private loading = false;

  private errMessage = '';
  private infoMessage = '';

  private form: any = {
    mangoPay: this.client.mangoPayStatementDescriptor
      ? this.client.mangoPayStatementDescriptor
      : '',
    deliveryService: this.client.deliveryService
      ? this.client.deliveryService
      : null,
    fbAppId: this.client.fbAppId ? this.client.fbAppId : '',
    fbAppPwd: this.client.fbAppPwd ? this.client.fbAppPwd : '',
    gaTrackingId: this.client.gaTrackingId ? this.client.gaTrackingId : '',
    clientId: this.client.clientId,
    deliverySetup: this.client.deliverySetup,
    clientSetup: this.client.clientSetup,
    step: this.client.setupStatus ? this.client.setupStatus.step : 9,
  };

  private data() {
    return {
      selected: null,
      options: [
        { value: null, text: 'Please select an option' },
        { value: 'ad_hoc', text: 'AD_HOC' },
        { value: 'email', text: 'EMAIL' },
        { value: 'stuart', text: 'STUART' },
        { value: 'shargo', text: 'SHARGO' },
      ],
    };
  }

  private created() {
    this.form.step = this.step;
  }

  private async onSubmit(event: any) {
    event.preventDefault();
    const validation = this.validateForm();
    if (validation === true) {
      try {
        this.loading = true;
        this.show = false;
        const response = await clients.secondStep(this.form);

        this.infoMessage = response.message;
        this.$emit('created', clients.getClient);

        this.loading = false;
        this.show = true;
      } catch (err) {
        this.errMessage = err.message;
        this.loading = false;
        this.show = true;
        this.$emit('created', null);
      }
    } else {
      this.errMessage = validation;
    }
  }

  private validateForm() {
    if (this.form.mangoPay.length > 10) {
      return 'Mango Pay descriptor should contain 10 chars max.';
    }

    if (RegExp('[^A-Z]').test(this.form.mangoPay)) {
      return 'Mango Pay descriptor should contain only capital letters';
    }

    return true;
  }
}
